import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IAcceptMeetingRequestByIDPayload } from '@app-store/slices/meetingRequests/acceptById'

interface TaskAction extends Action {
    payload: IAcceptMeetingRequestByIDPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.meetingRequests.acceptByID

function* acceptMeetingRequestByIDSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.put(`/meeting/meeting-requests/accept/${payload.requestId}`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            if (payload?.sagaCB?.onSuccess) payload.sagaCB.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
        if (payload?.sagaCB?.onError) payload?.sagaCB?.onError(error)
    }
}

function* acceptMeetingRequestByIDSaga(): any {
    yield takeLatest<TaskAction>(onRequest, acceptMeetingRequestByIDSagaTask)
}

export default acceptMeetingRequestByIDSaga
